'use client';

import { usePathname } from 'next/navigation';
import Script from 'next/script';
import { useEffect } from 'react';
import { env } from '~/env.mjs';

export default function Analytics() {
  const pathname = usePathname();
  
  useEffect(() => {
    pageview(pathname);
    
    // Initialize GTM in client-side only
    if (typeof window !== 'undefined' && process.env.NEXT_PUBLIC_VERCEL_ENV === 'production') {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js'
      });
      
      const gtmScript = document.createElement('script');
      gtmScript.async = true;
      gtmScript.src = `https://www.googletagmanager.com/gtm.js?id=${env.NEXT_PUBLIC_GTM}`;
      document.head.appendChild(gtmScript);
    }
  }, [pathname]);

  if (process.env.NEXT_PUBLIC_VERCEL_ENV !== 'production') {
    return null;
  }

  return (
    <>
      <noscript>
        <iframe
          src={`https://www.googletagmanager.com/ns.html?id=${env.NEXT_PUBLIC_GTM}`}
          height="0"
          width="0"
          style={{ display: 'none', visibility: 'hidden' }}
        />
      </noscript>
    </>
  );
}

type WindowWithDataLayer = Window & {
  dataLayer: Record<string, unknown>[];
};

declare const window: WindowWithDataLayer;

export const pageview = (url?: string) => {
  if (typeof window.dataLayer !== 'undefined' && url) {
    window.dataLayer.push({
      event: 'pageview',
      page: url,
    });
  }
};
